import React, { useRef } from "react";
import Footer from "./Footer";
import Header from "./Header";
import exportToExcel from "../Report/ExportExcel";

const passengerTableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  marginBottom: "20px",
};

const thTdStyle = {
  padding: "8px",
  border: "1px solid #ddd",
  textAlign: "left",
};

const thStyle = {
  backgroundColor: "#f2f2f2",
};

const SubscriberListss = ({ prRef, data, name }) => {
  const columns = [
    "Id",
    "First Name",
    "Last Name",
    "Gender",
    "Phone",
    "Address",
    "Rating",
    "Usage Limit",

    "Status",
  ];

  return (
    <div ref={prRef}>
      <Header
        title={"Subscribers Information"}
        subTitle={`Here is subscribers of ${name} for`}
      />
      <table style={passengerTableStyle}>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column} style={{ ...thTdStyle, ...thStyle }}>
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((trip, index) => (
            <tr key={index}>
              <td style={thTdStyle}>{trip.id}</td>
              <td style={thTdStyle}>{trip.firstName}</td>
              <td style={thTdStyle}>{trip.lastName}</td>

              <td style={thTdStyle}>{trip.Gender}</td>
              <td style={thTdStyle}>{trip.phoneNumber}</td>
              <td style={thTdStyle}>{trip.address}</td>
              <td style={thTdStyle}>{trip.rating}</td>
              <td style={thTdStyle}>{trip.usageLimit}</td>

              <td style={thTdStyle}>{trip.status}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <Footer />
    </div>
  );
};

export const exportExcelSubscriberList = (name, data) => {
  const formattedData = data.map((subscriber) => ({
    Id: subscriber.id,
    "First Name": subscriber.firstName,
    "Last Name": subscriber.lastName,
    Gender: subscriber.Gender,
    Phone: subscriber.phoneNumber,
    Address: subscriber.address,
    Rating: subscriber.rating,
    "Usage Limit": subscriber.usageLimit,
    Status: subscriber.status,
  }));

  exportToExcel(formattedData, `SubscriberList_${name}`, [
    "Id",
    "First Name",
    "Last Name",
    "Gender",
    "Phone",
    "Address",
    "Rating",
    "Usage Limit",
    "Status",
  ]);
};

export default SubscriberListss;
